import React from 'react';

import {
  Body,
  H5,
  Link,
  Stack,
  useModals,
  useWindowProperties,
} from '@qred/components-library';

import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import {
  AnimatedWrapper,
  CheckpointContent,
  CheckpointPage,
  ContentCard,
} from './Checkpoint.styles';
import { UniqueSellingPoints } from './components/UniqueSellingPoints/UniqueSellingPoints';
import useTranslate from '~/hooks/useTranslate';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { UniqueSellingPointsModal } from './components/UniqueSellingPointsModal/UniqueSellingPointsModal';
import { StepStatus } from '~/enums';
import { VerticalTimeline } from './components/VerticalTimeline/VerticalTimeline';
import NextStepButton from '../../buttons/NextStepButton/NextStepButton';
import { goToNextStep } from '~/store/slices/updateApplication/updateApplication.slice';

const CheckPoint = () => {
  const t = useTranslate();
  const { isMobile } = useWindowProperties();
  const { openModal, closeModal } = useModals();
  const dispatch = useAppDispatch();

  const handleBoostApplication = async () => {
    try {
      // Note keeping the pushToGtmLoanAction for now,
      // should we keep triggering these events
      // for the update application flow aswell?
      dispatch(
        pushToGtmLoanAction({
          actionName: 'boost_application_button_pressed',
        })
      );
      dispatch(goToNextStep());
      closeModal('unique-selling-points-modal');
    } catch (error: any) {
      dispatch(
        pushToGtmLoanAction({
          stepStatus: StepStatus.Error,
          errorMessage: error.response?.data?.message,
        })
      );
    }
  };

  const openUSPModal = () => {
    openModal({
      title: t('Onboarding.CheckpointUSPPrompt'),
      id: 'unique-selling-points-modal',
      children: (
        <UniqueSellingPointsModal
          handleBoostApplication={handleBoostApplication}
        />
      ),
    });
  };

  return (
    <CheckpointPage data-testid="update_application_checkpoint">
      <CheckpointContent>
        <AnimatedWrapper spacing={isMobile ? 'sm' : 'xl'} align="start">
          <H5 data-record>{t('Onboarding.CheckpointTitle')}</H5>
          <Body size="lg" data-record>
            {t('Onboarding.CheckpointDescription')}
          </Body>
          {!isMobile && <UniqueSellingPoints />}
          {isMobile && (
            <Link onClick={openUSPModal} data-record>
              {t('Onboarding.CheckpointUSPPrompt')}
            </Link>
          )}
        </AnimatedWrapper>
        <img src="/qrayon20_small.png" alt="" />
        <img src="/image_transparent_man_002_small.png" alt="" />
        <Stack spacing="xl">
          <ContentCard>
            <VerticalTimeline />
          </ContentCard>
        </Stack>
        <Stack align="center" pt={0}>
          <NextStepButton />
        </Stack>
      </CheckpointContent>
    </CheckpointPage>
  );
};

export default CheckPoint;
